import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbPaymentMode } from '../../../models'

export const MB_PAYMENT_MODE_NORMALIZER = new InjectionToken<Converter<any, MbPaymentMode[]>>('MbPaymentModeNormalizer')
